import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingInfo: false,
  isDownloading: false,
  isChecking: false,

  result: [],
};

const authAttachReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

  case types.GET_ATTACH_INFO_REQUEST:
    return {
      ...state,
      result: [],
      isFetchingInfo: true,
    };

  case types.GET_ATTACH_INFO_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetchingInfo: false,
    };

  case types.GET_ATTACH_INFO_FAILURE:
    return {
      ...state,
      result: [],
      isFetchingInfo: false,
    };

  case types.DOWNLOAD_ATTACHMENT_REQUEST:
    return {
      ...state,
      result: [],
      isDownloading: true,
    };

  case types.DOWNLOAD_ATTACHMENT_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isDownloading: false,
    };

  case types.DOWNLOAD_ATTACHMENT_FAILURE:
    return {
      ...state,
      result: [],
      isDownloading: false,
    };

  case types.CHECK_REQUIRED_REQUEST:
    return {
      ...state,
      result: [],
      isChecking: true,
    };

  case types.CHECK_REQUIRED_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isChecking: false,
    };

  case types.CHECK_REQUIRED_FAILURE:
    return {
      ...state,
      result: [],
      isChecking: false,
    };

  default:
    return state;
  }
};

export default authAttachReducer;
